import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button, Modal, TextField, CircularProgress } from '@material-ui/core';
import styled from 'styled-components';
import ValidateUser from '../UserStatus';

const TEN = 10;
const FIFTY = 50;

const CreateGroupModal = styled.div`
  top: ${FIFTY}%;
  left: ${FIFTY}%;
  transform: translate(-${FIFTY}%, -${FIFTY}%);

  h2,
  h3 {
    margin-bottom: ${TEN}px;
  }
`;

const styles = makeStyles(theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  pricingLoadingModalPaper: {
    position: 'absolute',
    width: theme.spacing(FIFTY),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
  createGroupModalHeaderText: {
    '& span': {
      marginRight: '10px',
    },
  },
  createGroupButtonWrap: {
    marginTop: theme.spacing(2),
  },
  iconOnly: {
    marginRight: '10px',
  },
}));

const NewGroupModal = props => {
  const {
    // createGroupModalOpen,
    isModalOpen,
    createGroupSaveButtonClicked,
    currGroupName,
    createGroupNameInputChanged,
    createGroupSaveButtonDisabled,
    createGroupCancelButtonClicked,
    isLoading,
  } = props;

  const classes = styles();
  return (
    <Modal
      aria-labelledby="Create Grouping"
      aria-describedby="Modal for Create Grouping"
      open={isModalOpen}
      data-testid="create-group-modal"
    >
      <CreateGroupModal className={classes.pricingLoadingModalPaper}>
        <ValidateUser />
        <Typography variant="h6" id="modal-title">
          Create grouping
        </Typography>
        <Typography variant="subtitle1" id="simple-modal-description" className={classes.createGroupModalHeaderText}>
          Please choose a name for your grouping
        </Typography>
        <form autoComplete="off" onSubmit={createGroupSaveButtonClicked}>
          <TextField
            value={currGroupName}
            onChange={createGroupNameInputChanged}
            name="groupName"
            inputProps={{ 'data-testid': 'create-group-modal-textfield' }}
          />
          <div className={classes.createGroupButtonWrap}>
            <Button
              variant="contained"
              color="primary"
              disabled={createGroupSaveButtonDisabled || isLoading}
              onClick={createGroupSaveButtonClicked}
              style={{ width: '100%' }}
              data-testid="confirm-group-creation-button"
            >
              Create Group
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
            <Button
              variant="contained"
              onClick={createGroupCancelButtonClicked}
              style={{ width: '100%', marginTop: '10px' }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </CreateGroupModal>
    </Modal>
  );
};

NewGroupModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  createGroupSaveButtonClicked: PropTypes.func.isRequired,
  createGroupNameInputChanged: PropTypes.func.isRequired,
  createGroupSaveButtonDisabled: PropTypes.bool.isRequired,
  createGroupCancelButtonClicked: PropTypes.func.isRequired,
  currGroupName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default NewGroupModal;
